export const SET_ORGANIZATION_DATA='SET_ORGANIZATION_DATA'